import Header from '../components/SideBar'

export default function NoPage() {
    return (
        <>
            <Header/>
            <h2>Error 404 Page Not Found</h2>
        </>
    )
}